<template>
    <div class="table-layout">
        <el-table :data="devcCatAuditRecList" border style="width: 100%">
            <el-table-column prop="auditTime" label="审核时间" align="center" width="160"></el-table-column>
            <el-table-column prop="auditorPostName" label="审核岗位" align="left" width="140"></el-table-column>
            <el-table-column prop="auditorName" label="审核人" align="left" width="140"></el-table-column>
            <el-table-column prop="auditState" label="审核状态" align="center" width="120">
                <template slot-scope="rows">
                    <span v-if="rows.row.applyState == 0">未申请</span>
                    <span v-else-if="rows.row.applyState == 1" class="font-green">已申请</span>
                    <span v-else-if="rows.row.auditState == 1" class="font-green">审核已通过</span>
                    <span v-else-if="rows.row.auditState == -1" class="font-red">审核未通过</span>
                </template>
            </el-table-column>
            <el-table-column prop="auditDesc" label="审核意见" align="left"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'

    import shopDevcApi from '../../api/shopDevc'

    export default {
        name: 'swb-devc-cat-audit-rec-list',
        desc: '资产分类',
        props: ['devcCatId'],
        data: function () {
            return {
                devcCatAuditRecList: [],
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                }
            }
        },
        created: function () {
            //
            this.getDevcCatAuditRecList();
        },
        methods: {
            getDevcCatAuditRecList: function () {
                let self = this;
                let postData = {};
                postData.devcCatId = self.devcCatId;
                let theLoad = MsgBox.loading();
                shopDevcApi.getDevcCatAuditRecList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        //
                        self.devcCatAuditRecList = result.data || [];
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/categ/DevcCatAuditRecList.vue